// extracted by mini-css-extract-plugin
export default {"title":"EmailNameAndPassword_title__MUkrk"};